<template>
	<div class="fluid grid" v-if="!isLoading">
		<div class="col-12">
			<h5 class="mb-0 pl-0">
				{{receivedData.companyName}}
				<router-link :to="{ name: 'CompanyDetails', params: { companyId: receivedData.companyId }}" v-if="isInternalUser">
					<i class="pi pi-external-link p-1" style="font-size: 1rem;" />
				</router-link>
			</h5>
		</div>

		<div class="col-2 label">
			Phone
		</div>
		<div class="col-10">
			{{receivedData.companyPhone}}
		</div>

		<div class="col-2 label">
			Address
		</div>
		<div class="col-10">
			{{receivedData.streetAddress}}
		</div>

		<div class="col-2 label">Postal</div>
		<div class="col-10">
			{{receivedData.postalAddress}}
		</div>


		<div class="col-2 label">Suburb</div>
		<div class="col-10">
			{{receivedData.suburb}}
		</div>


		<div class="col-2 label">City/Town</div>
		<div class="col-10">
			{{receivedData.city}}
		</div>

		<template v-if="receivedData.postCode && receivedData.postCode.length>1">
			<div class="col-2 label">Postcode</div>
			<div class="col-10">
				{{receivedData.postCode}}
			</div>
		</template>

		<template v-if="receivedData.companyNotes && receivedData.companyNotes.length > 1 && $store.getters.isInternalUser">
			<div class="col-2 label">Company Notes</div>
			<div class="col-10 pre-wrap">
				{{receivedData.companyNotes.trim()}}
			</div>
		</template>
	</div>

	<div v-if="!isLoading">
		<h5 class="mt-5">Contacts</h5>
		<Contacts :contacts="receivedData.contacts" view="indented-list" />
	</div>

	<ProgressSpinner v-if="isLoading" />
</template>

<script lang="ts">
	import { Vue } from 'vue-class-component';
	import { Prop } from 'vue-property-decorator';
	import { CompassApi } from '@/api-client/CompassApiProxy'
	import { CompanyData } from '../api-client/api-client'
	import Toast from '@/utils/Toast';

	export default class CompanyDetails extends Vue {

		@Prop({ type: Number, required: true }) companyId!: number;

		receivedData: CompanyData = new CompanyData;

		isLoading = true;

		isInternalUser = false;

		created() {
			// Set initial name (if available)
			this.isInternalUser = this.$store.getters.isInternalUser;
			const list = this.$store.state.companyList.data;
			try {
				const rec = list.filter((r) => r.id == this.companyId);
				if (rec.length > 0)
					this.receivedData.companyName = rec[0].name;
			}
			catch (e) { console.error('Note company list not loaded:' + e) }

			// Retrieve data from API
			const apiClient = CompassApi.companyApi(this.$store);
			apiClient.getCompanyById(this.companyId)
				.then(result => {
					if (result && result.contacts) {
						this.isLoading = false;
						this.receivedData = result
					}
				})
				.catch(error => {
					this.isLoading = false;
					Toast.ApiError('Error loading company ' + this.companyId, error);
				});
		}
	}
</script>

<style scoped lang="scss">
</style>